<template>
  <div id="panneauxNumerique" class="topRouge" v-if="detailPanneauxNumeriqueFilter.length">
    <p class="p_size18 has-text-weight-bold has-text-link bottomVert">
      <b-icon
        icon="circle"
        size="is-small"
        class="circleStyleMobile">
      </b-icon>
      Proposition face(s) numérique(s)
    </p>
    <div>
      <app-carte-panneaux-numerique :markers="detailPanneauxNumeriqueFilter"
      :markerVenteNumerique="markerVenteNumerique"/>
    </div>
    <p class="p_size14 has-text-weight-bold has-text-link bottomVert topVert">
      Liste face(s) numérique(s)
    </p>
    <app-listes-faces-numerique :detailPanneauxNumerique="detailPanneauxNumeriqueFilter"/>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import cartePanneauxNumerique from './cartePanneauxNumerique';
import listesFacesNumerique from './listesFacesNumerique';

export default {
  name: 'index',
  props: ['detailPanneauxNumerique', 'adresseVenteNumerique'],
  components: {
    appCartePanneauxNumerique: cartePanneauxNumerique,
    appListesFacesNumerique: listesFacesNumerique,
  },
  data() {
    return {
      markerVenteNumerique: {},
    };
  },
  computed: {
    detailPanneauxNumeriqueFilter() {
      return this.detailPanneauxNumerique.filter(d => !d.extensionOpportunite.reseauPersoGuid);
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseVenteNumerique.lat !== undefined) {
        this.markerVenteNumerique = {
          ...this.adresseVenteNumerique,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxNumeriques/index.vue